import React, { useState, useEffect, useRef } from "react";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";

const TextBlock = ({
  onRemove,
  autoFocus,
  text,
  onChangeText
}) => {
  const [localDescription, setLocalDescription] = useState(text || "");
  const [isUserEditing, setIsUserEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);


  const handleDescriptionChange = (name, value) => {
    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      onChangeText(value);
    }
    // Reset editing flag after a short delay to allow for user interaction
    setTimeout(() => setIsUserEditing(false), 100);
  };

  useEffect(() => {
    if (!isUserEditing) {
      // console.log("useEffect updating localDescription from props");
      setLocalDescription(text || "");
    }
  }, [text]);

  return (
    <div className="block-container">
      <div className="block-header">
        <h4 className="block-title">Text Block</h4>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="col-lg-10 mb-4">
          <div className="form-group">
            <RichTextEditor
              ref={inputRef}
              name="description"
              onChange={handleDescriptionChange}
              value={localDescription}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextBlock;
